import { SeoHead } from "@/components/SeoHead"
import { MarketingLayout } from "@/components/marketing/MarketingLayout"
import { Section } from "@/components/marketing/sections/Section"

const DESCRIPTION =
  "The terms that govern your use of the FullCast website and application."

export default function Terms() {
  return (
    <MarketingLayout>
      <SeoHead title="Terms of Use" description={DESCRIPTION} />

      <Section containerClassName="max-w-3xl">
        <h1 className="display-2">Terms of Use</h1>
        <p className="mt-3 text-sm text-ink-muted">Last updated: 2026</p>

        <div className="callout callout-signal mt-6 text-sm">
          This is placeholder legal copy. Have it reviewed by a qualified
          professional and tailored to FullCast before launch.
        </div>

        <div className="body-content mt-8">
          <p>
            By accessing this website, you agree to these terms. If you do not
            agree, please do not use the site.
          </p>
          <h2>Use of the site</h2>
          <p>
            This website and its content are provided for informational purposes.
            You agree to use the site lawfully and not to misuse or disrupt it.
          </p>
          <h2>Applications and the Fit Call</h2>
          <p>
            Submitting an application does not create an obligation on either side.
            FullCast reserves the right to decline applications and to determine
            fit for the FullCast Podcast Growth Partnership at its discretion.
          </p>
          <h2>Intellectual property</h2>
          <p>
            The FullCast name, content, and original frameworks on this site are
            the property of FullCast and may not be reproduced without permission.
          </p>
          <h2>No guarantees</h2>
          <p>
            FullCast helps clients improve their positioning, conversations,
            podcast structure, and authority-building content. We do not guarantee
            specific business results, leads, or revenue.
          </p>
          <h2>Contact</h2>
          <p>
            Questions about these terms? Reach us through our{" "}
            <a href="/apply">contact form</a>.
          </p>
        </div>
      </Section>
    </MarketingLayout>
  )
}
